module.exports = __webpack_public_path__ + "img/Butterfly_00325.38e8660f.png";